import Collection from "@/lib/vulcan-lib/ClientCollection";
// eslint-disable-next-line no-barrel-files/no-barrel-files
export default Collection;
